<template>
  <span>
    <el-button type="primary" :size="btnSize" @click="showDialog()"
      icon="el-icon-plus">Add Monthly fee Credit</el-button
    >

    <el-dialog
      :title="'Add Monthly fee Credit BankholderID : ' + bankholderID"
      :visible.sync="dialogVisible"
      :width="device === 'mobile' ? '95%' : '40%'"
      top="5vh"
    >
      <el-form
        :model="formData"
        ref="addCreditForm"
        label-width="150px"
        size="small"
        :rules="formDataRule"
        :label-position="device === 'mobile' ? 'top' : 'right'"
      >
        <el-form-item label="Type" prop="type">
          <el-select v-model="formData.type">
            <el-option label="Debit" value="debit"></el-option>
            <el-option label="Credit" value="credit"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Amount" prop="amount">
          <el-input
            type="number"
            v-model="formData.amount"
            autocomplete="off"
          ></el-input>
        </el-form-item>

        <el-form-item label="Description" prop="description">
          <el-input type="textarea" v-model="formData.description"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="submitAddCredit()"
         :loading="submitting" >Submit</el-button
        >
      </span>
    </el-dialog>
  </span>
</template>

<script>
import { addCredit } from  '@/api/monthlyfeecredits'
export default {
  props: {
    btnSize: {
      type: String,
      default: "small",
    },
    bankholderID: String,
  },
  computed: {
    device() {
      return this.$store.state.app.device;
    },
  },
  data() {
    return {
      submitting: false,
      dialogVisible: false,
      formData: {
        amount: 0,
        description: "",
        bankholderID: this.bankholderID,
        type: "credit",
      },
      formDataRule: {
        amount: [
          {
            required: true,
            message: "Please enter Amount",
            trigger: "blur",
          },
          {
            min: 1,
            message: "Please enter Amount",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    showDialog() {
      this.dialogVisible = true;
    },
    submitAddCredit(){
      this.$refs.addCreditForm.validate(valid=>{
        if(valid){
          this.submitting = true
          addCredit(this.bankholderID, this.formData).then(({result})=>{
            this.submitting = false
            if(result){
              this.dialogVisible = false
              this.$notify({
                title: 'Success',
                message: `Add Credit successfully`,
                type: 'success',
                duration: 2000
              });
              this.$emit('submited')
            }
          })
        }
      })
    }
  },
};
</script>

<style>
</style>